export enum CurrencyMode {
    SLIM = "slim",
    FULL = "full",
}
